(function ($, Drupal) {
  'use strict';

  $.expr[":"].text = jQuery.expr.createPseudo(function (arg) {
    return function (elem) {
      return $(elem).text() == arg;
    };
  });

  $.expr[':'].contains = function (a, i, m) {
    return jQuery(a).text().toUpperCase()
      .indexOf(m[3].toUpperCase()) >= 0;
  };

  // global vars
  var medium = 641;
  var desktop = 1024;
  var pfx = ["webkit", "moz", "MS", "o", ""];


  Drupal.behaviors.aktionsfinder = {
    attach: function (context, settings) {


      $('.overlayerSelector').hide();
      //------- selectboxes aktions-finder big --------------------------
      var select = $('select[name^="aktionszeitraum"]:not(.select-hidden), select[name^="aktionsfelder"]:not(.select-hidden), select[name^="aktionsgruppe"]:not(.select-hidden), select[name^="bundesland"]:not(.select-hidden)');
      if (select.length > 0) {
        $(select).each(function () {
          var $this = $(this), numberOfOptions = $(this).children('option').length;
          var elSelectedCount = $this.children('option[selected=selected]').length;
          var nameEl = capitalizeFirstLetter($this.attr('name').replace("[]", ""));
          if (elSelectedCount == 1) {
            if (nameEl == "Aktionsfelder") {
              nameEl = "Aktionsfelder";
            }
            if (nameEl == "Aktionsgruppe") {
              nameEl = "Aktionsgruppe";
            }
            if (nameEl == "Aktionszeitraum") {
              nameEl = "Aktionszeitraum";
            }
            nameEl = elSelectedCount + " " + nameEl;
          } else if (elSelectedCount > 1) {
            if (nameEl == "Bundesland") {
              nameEl = "Bundesländer";
            }
            if (nameEl == "Aktionsgruppe") {
              nameEl = "Aktionsgruppen";
            }
            if (nameEl == "Aktionszeitraum") {
              nameEl = "Aktionszeiträume";
            }
            nameEl = elSelectedCount + " " + nameEl;
          }

          $this.addClass('select-hidden');
          $this.wrap('<div class="select multi"></div>');
          $this.after('<div class="select-styled">' + nameEl + '</div>');

          var $styledSelect = $this.next('div.select-styled');

          if (elSelectedCount > 0) {
            $styledSelect.addClass("greenFix");
          }

          var $listBox = $('<div />', {
            'class': 'select-options very-big'
          }).insertAfter($styledSelect);

          var $list = $('<ul />', {
            'class': 'listBox'
          }).appendTo($listBox);

          for (var i = 0; i < numberOfOptions; i++) {
            var labelText = $this.children('option').eq(i).text();
            $('<li />', {
              html: '<div><label for="' + labelText + '" class="option special-checkbox">' + labelText + '</label>',
              rel: $this.children('option').eq(i).val()
            }).appendTo($list).click(function () {
              var _that = $(this);
              var label = _that.find('label');
              var elText = _that.attr("rel");
              var checked = label.hasClass("checked");
              $this.find("option[value='" + elText + "']").prop("selected", !checked);
              label.toggleClass("checked");
              var elSelectedCount = $this.parent().find('label.checked').length;
              var nameEl = capitalizeFirstLetter($this.attr('name').replace("[]", ""));
              if (elSelectedCount > 0) {
                $styledSelect.addClass('greenFix');
              } else {
                $styledSelect.removeClass('greenFix');
              }
              if (elSelectedCount == 1) {
                if (nameEl == "Aktionsfelder") {
                  nameEl = "Aktionsfeld";
                }
                if (nameEl == "Aktionsgruppe") {
                  nameEl = "Aktionsgruppe";
                }
                nameEl = elSelectedCount + " " + nameEl;
              } else if (elSelectedCount > 1) {
                if (nameEl == "Bundesland") {
                  nameEl = "Bundesländer";
                }
                if (nameEl == "Aktionsgruppe") {
                  nameEl = "Aktionsgruppen";
                }
                if (nameEl == "Aktionszeitraum") {
                  nameEl = "Aktionszeiträume";
                }
                nameEl = elSelectedCount + " " + nameEl;
              }
              $styledSelect.text(nameEl);
            });
          }
          disableCheckboxesPerOption($styledSelect, 'bundesweit', 'Bundesland');

          $this.children('option[selected=selected]').each(function (i, e) {
            var elText = $(this).val();
            $listBox.find('li[rel="' + elText + '"] label').addClass("checked");
          });

          $('<input />', {
            'class': 'button border_blue block js-form-submit form-submit',
            'type': 'submit',
            'value': "Anwenden"
          }).appendTo($listBox);

          $styledSelect.click(function (e) {
            $('.overlayerSelector').toggle();
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
              $(this).removeClass('active').removeClass('green').next('.select-options').hide();
            });
            $(this).toggleClass('active').toggleClass('green').next('.select-options').toggle();
          });
        });
      }
      //------- selectboxes nettie-finder big --------------------------

    }
  };

  $(document).ready(function () {
      // ---- visibility ----- zeugs
      $('.aktions-finder-front .exposed-form-container').css('visibility', 'visible');
      $('body.domain_freischwimmen form.webform-submission-aktionsformular-form').css('visibility', 'visible');

      // end---- visibility ----- zeugs

      //-----selectboxes nettie-finder-----
      var selectsStyled = $('.select-styled.fs-custom');
      selectsStyled.click(function (e) {
        $('.overlayerSelector').toggle();
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function () {
          $(this).removeClass('active').removeClass('green').next('.select-options').hide();
        });
        $(this).toggleClass('active').toggleClass('green').next('.select-options').toggle();
      });
      selectsStyled.next().find('li').click(function () {

        var _that = $(this);
        var label = _that.find('label');
        if (!label.hasClass('disabled')) {
          var elText = _that.attr("rel");
          var checked = label.hasClass("checked");
          _that.closest('.select').find("select option[value='" + elText + "']").prop("selected", !checked);
          label.toggleClass("checked");
          if (elText == "bundesweit") {
            //console.log("test");
            _that.closest('.select').find('li').not(_that).find('label').removeClass('checked');
            _that.closest('.select').find("select option").not("[value='" + elText + "']").prop('selected', false);
            if (label.hasClass('checked')) {
              _that.closest('.select').find('li').not(_that).find('label').addClass('disabled');
            } else {
              _that.closest('.select').find('li').not(_that).find('label').removeClass('disabled');
            }
          }
        }
      });
      selectsStyled.each(function () {
        var __that = $(this);
        var labelBundesweit = __that.next().find('li label[for="bundesweit"].checked');
        if (labelBundesweit.length > 0) {
          __that.next().find('li label').not(labelBundesweit).removeClass("checked");
          __that.next().find('li label').not(labelBundesweit).addClass("disabled");
        }
      });
      selectsStyled.next().find('input[type="text"]').on("input", function () {
        var _that = $(this);
        var val = _that.val().toLowerCase();
        _that.parent().next(".listBox").find("li").hide();
        _that.parent().next(".listBox").find("label:contains(" + val + ")").closest("li").show();
      });

      //show hidden region-dropdowns
      // $('.form-item-bundesland select').children('option[selected=selected]').each(function (i, e) {
      //   var elText = $(e).val();
      //   if (elText != "bundesweit") {
      //     $('.extraFilterWrapperOuter strong').addClass("show");
      //   }
      //   var elements = $('div[class*="form-item-aktionsradius-"]').find('label:text("' + elText + '")').closest('div[class*=form-item-aktionsradius]');
      //   elements.addClass('show');
      //
      // });
      //-----ende: selectboxes aktions-finder-----

      // $(document).on("click", ".moreFiltersFs", function () {
      //   var extraFilters = $('.extrafilters');
      //   var extraFilterWrapper = $('.extraFilterWrapper');
      //   var extraFilterWrapperOuter = $('.extraFilterWrapperOuter');
      //   extraFilters.toggleClass("open");
      //   if (!extraFilters.hasClass('open')) {
      //     extraFilterWrapperOuter.removeClass('shower');
      //     extraFilters.height(extraFilterWrapper.get(0).scrollHeight);
      //     extraFilters.animate({
      //       height: 0
      //     }, {
      //       duration: 500,
      //       queue: false,
      //       easing: 'easeInOutSine',
      //       step: function () {
      //         extraFilters.css("overflow", "visible");
      //       }
      //     });
      //     Cookies.set('exposedFilterSpecial', '');
      //   } else {
      //     extraFilters.height(0);
      //     extraFilters.animate({
      //       height: extraFilterWrapper.get(0).scrollHeight
      //     }, {
      //       duration: 500,
      //       queue: false,
      //       easing: 'easeInOutSine',
      //       step: function () {
      //         extraFilters.css("overflow", "visible");
      //       },
      //       complete: function () {
      //         $(this).height('auto');
      //         extraFilterWrapperOuter.addClass('shower');
      //       }
      //     });
      //     Cookies.set('exposedFilterSpecial', 'open');
      //   }
      // });

      $(document).click(function (e) {
        var multiValueLength = $(e.target).closest('.select.multi').length;
        if (multiValueLength < 1) {
          $('div.select-styled').removeClass('active').removeClass('green');
          $('.select-options').hide();
          $('.overlayerSelector').hide();
        }
      });

    //  sort by title and Date from
    $(document).on("click", ".tabulators .sorter .sort-selector li", function () {
      var _that = $(this);
      var formSubmit = $('form#views-exposed-form-aktions-finder-page-1 .form-actions > input[type="submit"]');
      if (_that.attr('data-sort') === "abisz") {
        $('#edit-sort-by').val('title').change();
        $('#edit-sort-order').val('ASC').change();
        // Cookies.set('nettieFilterSortBy', 'field_stiftung_organisation');
        // Cookies.set('nettieFilterSortOrder', 'ASC');
        formSubmit.click();
      }
      if (_that.attr('data-sort') === "zbisa") {
        $('#edit-sort-by').val('title').change();
        $('#edit-sort-order').val('DESC').change();
        // Cookies.set('nettieFilterSortBy', 'field_stiftung_organisation');
        // Cookies.set('nettieFilterSortOrder', 'DESC');
        formSubmit.click();
      }
      if (_that.attr('data-sort') === "date_asc") {
        $('#edit-sort-by').val('field_datum_ab').change();
        $('#edit-sort-order').val('ASC').change();
        // Cookies.set('aktionsFilterSortBy', 'field_datum_ab');
        // Cookies.set('aktionsFilterSortOrder', 'ASC');
        formSubmit.click();
      }
      // if (_that.attr('data-sort') === "date_desc") {
      //   $('#edit-sort-by').val('field_datum_ab').change();
      //   $('#edit-sort-order').val('DESC').change();
      //   // Cookies.set('aktionsFilterSortBy', 'field_datum_ab');
      //   // Cookies.set('aktionsFilterSortOrder', 'DESC');
      //   formSubmit.click();
      // }
    });


    }//document ready
  );//document ready

  function disableCheckboxesPerOption(select, option, selectText) {
    select.next().find('li').click(function () {
      var _that = $(this);
      var label = _that.find('label');
      if (!label.hasClass('disabled')) {
        var elText = _that.attr("rel");
        if (elText === option) {
          _that.closest('.select-options').parent().find('.select-styled').text(capitalizeFirstLetter(option));
          _that.closest('.select').find('li').not(_that).find('label').removeClass('checked');
          _that.closest('.select').find("select option").not("[value='" + elText + "']").prop('selected', false);
          if (label.hasClass('checked')) {
            _that.closest('.select').find('li').not(_that).find('label').addClass('disabled');
            _that.closest('.select').find('li').not(_that).addClass('disabled');
          } else {
            _that.closest('.select').find('li').not(_that).find('label').removeClass('disabled');
            _that.closest('.select').find('li').not(_that).removeClass('disabled');
            _that.closest('.select-options').parent().find('.select-styled').text(capitalizeFirstLetter(selectText));

          }
        }
      }
    });
  }


})(jQuery, Drupal);

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

